// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BottomNav_bottomNav__Y\\+JRF {
  display: flex;
  padding: 8px 0;
  justify-content: space-between;
  z-index: 100;
  background: var(--background-tertiary);
}
.BottomNav_bottomNav__Y\\+JRF a {
  display: flex;
  flex-direction: column;
  font-size: 0.63em;
  align-items: center;
  width: 20%;
  justify-content: center;
  color: var(--text-secondary);
  font-weight: 500;
}
.BottomNav_bottomNav__Y\\+JRF svg {
  width: 20px;
  height: 20px;
  margin-bottom: 5px;
  stroke: var(--icon-primary);
}
.BottomNav_bottomNav__Y\\+JRF svg path {
  stroke: var(--icon-primary);
}

.BottomNav_unread_icon__cnA7L {
  position: relative;
}
.BottomNav_unread_icon__cnA7L::before {
  content: "";
  position: absolute;
  top: 0px;
  left: 15px;
  z-index: 250;
  width: 5px;
  height: 5px;
  background: var(--support-danger-default);
  border-radius: 100%;
}

.BottomNav_moreOpt__AgEyu {
  width: 20%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.BottomNav_moreOpt__AgEyu button {
  display: flex;
  flex-direction: column;
  font-size: 0.63em;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary);
}

.BottomNav_moreOptIn__gf8Pl {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 300;
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
  background: var(--background-tertiary);
  border-top: 1px solid var(--border-tertiary);
  box-shadow: 0 0 8px 2px var(--box-shadow-primary);
  display: none;
  width: 100%;
}
.BottomNav_moreOptIn__gf8Pl > div {
  position: relative;
  width: 100%;
  height: 100%;
}
.BottomNav_moreOptIn__gf8Pl button {
  position: absolute;
  top: 20px;
  right: 20px;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.BottomNav_moreOptIn_on__RJMqB {
  display: block;
}

.BottomNav_more_wrapper__idG3f {
  display: flex;
  padding: 60px 20px;
  flex-wrap: wrap;
  justify-content: center;
}
.BottomNav_more_wrapper__idG3f a {
  width: 100px;
  margin-top: 15px;
  margin-bottom: 5px;
  text-align: center;
}
.BottomNav_more_wrapper__idG3f a svg,
.BottomNav_more_wrapper__idG3f a img {
  width: 25px;
  height: 25px;
}
.BottomNav_more_wrapper__idG3f .BottomNav_sidebar_icon__gGIlA {
  margin-bottom: 5px;
}
.BottomNav_more_wrapper__idG3f .BottomNav_sidebar_icon__gGIlA path {
  stroke: var(--icon-primary);
}

.BottomNav_active_tab__lARVR {
  color: var(--text-link) !important;
}
.BottomNav_active_tab__lARVR svg,
.BottomNav_active_tab__lARVR path {
  stroke: var(--text-link) !important;
  color: var(--text-link) !important;
}

@keyframes BottomNav_slidedown__mWNyj {
  from {
    bottom: 0px;
  }
  to {
    bottom: -300px;
  }
}
@keyframes BottomNav_slideup__5ymNU {
  from {
    bottom: -300px;
  }
  to {
    bottom: 0px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/shared/BottomNav/BottomNav.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,cAAA;EACA,8BAAA;EACA,YAAA;EACA,sCAAA;AACD;AACC;EACC,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,UAAA;EACA,uBAAA;EACA,4BAAA;EACA,gBAAA;AACF;AAEC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;AAAF;AAEE;EACC,2BAAA;AAAH;;AAKA;EACC,kBAAA;AAFD;AAIC;EACC,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,yCAAA;EACA,mBAAA;AAFF;;AAMA;EACC,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAHD;AAKC;EACC,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,4BAAA;AAHF;;AAOA;EACC,eAAA;EACA,OAAA;EACA,SAAA;EACA,YAAA;EAGA,6BAAA;EACA,4BAAA;EACA,sCAAA;EACA,4CAAA;EACA,iDAAA;EACA,aAAA;EACA,WAAA;AAND;AAQC;EACC,kBAAA;EACA,WAAA;EACA,YAAA;AANF;AASC;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAPF;;AAWA;EACC,cAAA;AARD;;AAWA;EACC,aAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;AARD;AAUC;EACC,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AARF;AAUE;;EAEC,WAAA;EACA,YAAA;AARH;AAYC;EACC,kBAAA;AAVF;AAyBE;EACC,2BAAA;AAvBH;;AA4BA;EACC,kCAAA;AAzBD;AA2BC;;EAEC,mCAAA;EACA,kCAAA;AAzBF;;AAqCA;EACC;IACC,WAAA;EAlCA;EAqCD;IACC,cAAA;EAnCA;AACF;AAsCA;EACC;IACC,cAAA;EApCA;EAuCD;IACC,WAAA;EArCA;AACF","sourcesContent":[".bottomNav {\n\tdisplay: flex;\n\tpadding: 8px 0;\n\tjustify-content: space-between;\n\tz-index: 100;\n\tbackground: var(--background-tertiary);\n\n\ta {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tfont-size: 0.63em;\n\t\talign-items: center;\n\t\twidth: 20%;\n\t\tjustify-content: center;\n\t\tcolor: var(--text-secondary);\n\t\tfont-weight: 500;\n\t}\n\n\tsvg {\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\tmargin-bottom: 5px;\n\t\tstroke: var(--icon-primary);\n\n\t\tpath {\n\t\t\tstroke: var(--icon-primary);\n\t\t}\n\t}\n}\n\n.unread_icon {\n\tposition: relative;\n\n\t&::before {\n\t\tcontent: \"\";\n\t\tposition: absolute;\n\t\ttop: 0px;\n\t\tleft: 15px;\n\t\tz-index: 250;\n\t\twidth: 5px;\n\t\theight: 5px;\n\t\tbackground: var(--support-danger-default);\n\t\tborder-radius: 100%;\n\t}\n}\n\n.moreOpt {\n\twidth: 20%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\tbutton {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tfont-size: 0.63em;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tcolor: var(--text-secondary);\n\t}\n}\n\n.moreOptIn {\n\tposition: fixed;\n\tleft: 0;\n\tbottom: 0;\n\tz-index: 300;\n\t// bottom: -300px;\n\t// width: 100%;\n\tborder-top-right-radius: 20px;\n\tborder-top-left-radius: 20px;\n\tbackground: var(--background-tertiary);\n\tborder-top: 1px solid var(--border-tertiary);\n\tbox-shadow: 0 0 8px 2px var(--box-shadow-primary);\n\tdisplay: none;\n\twidth: 100%;\n\n\t> div {\n\t\tposition: relative;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t}\n\n\tbutton {\n\t\tposition: absolute;\n\t\ttop: 20px;\n\t\tright: 20px;\n\t\tpadding: 5px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t}\n}\n\n.moreOptIn_on {\n\tdisplay: block;\n}\n\n.more_wrapper {\n\tdisplay: flex;\n\tpadding: 60px 20px;\n\tflex-wrap: wrap;\n\tjustify-content: center;\n\n\ta {\n\t\twidth: 100px;\n\t\tmargin-top: 15px;\n\t\tmargin-bottom: 5px;\n\t\ttext-align: center;\n\n\t\tsvg,\n\t\timg {\n\t\t\twidth: 25px;\n\t\t\theight: 25px;\n\t\t}\n\t}\n\n\t.sidebar_icon {\n\t\tmargin-bottom: 5px;\n\t\t// position: relative;\n\n\t\t// &::before {\n\t\t// \tcontent: \"a\";\n\t\t// \tposition: absolute;\n\t\t// \ttop: 0px;\n\t\t// \tleft: 15px;\n\t\t// \tz-index: 1000;\n\t\t// \twidth: 5px;\n\t\t// \theight: 5px;\n\t\t// \tbackground: var(--support-danger-default);\n\t\t// \tborder-radius: 100%;\n\t\t// }\n\n\t\tpath {\n\t\t\tstroke: var(--icon-primary);\n\t\t}\n\t}\n}\n\n.active_tab {\n\tcolor: var(--text-link) !important;\n\n\tsvg,\n\tpath {\n\t\tstroke: var(--text-link) !important;\n\t\tcolor: var(--text-link) !important;\n\t}\n}\n\n// .moreOptIn_remove {\n// \tanimation: slidedown 0.3s;\n// }\n\n// .moreOptIn_on {\n// \tanimation: slideup 0.3s;\n// }\n\n@keyframes slidedown {\n\tfrom {\n\t\tbottom: 0px;\n\t}\n\n\tto {\n\t\tbottom: -300px;\n\t}\n}\n\n@keyframes slideup {\n\tfrom {\n\t\tbottom: -300px;\n\t}\n\n\tto {\n\t\tbottom: 0px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bottomNav": `BottomNav_bottomNav__Y+JRF`,
	"unread_icon": `BottomNav_unread_icon__cnA7L`,
	"moreOpt": `BottomNav_moreOpt__AgEyu`,
	"moreOptIn": `BottomNav_moreOptIn__gf8Pl`,
	"moreOptIn_on": `BottomNav_moreOptIn_on__RJMqB`,
	"more_wrapper": `BottomNav_more_wrapper__idG3f`,
	"sidebar_icon": `BottomNav_sidebar_icon__gGIlA`,
	"active_tab": `BottomNav_active_tab__lARVR`,
	"slidedown": `BottomNav_slidedown__mWNyj`,
	"slideup": `BottomNav_slideup__5ymNU`
};
export default ___CSS_LOADER_EXPORT___;
